import axios from "axios";
import { setToastData } from "../Store/reducers/Toast";
import { setErrorBoundry, setMainLoading } from "../Store/reducers/Common";
import { logoutUser } from "../Store/reducers/Users";
import store from "../Store";
export const CancelSource = axios.CancelToken.source();

const isUserNotExistResponse = (data) => {
	return (
		data &&
		`${data.status}` === "2" &&
		`${data.error}` === "1" &&
		`${data.message}` === "User does not exist !"
	);
};

const attachApiResponseMiddleware = (instance) => {
	instance.interceptors.response.use(
		(response) => {
			if (isUserNotExistResponse(response?.data)) {
				TokenExpireOnAPIRequest(store.dispatch, response.data);
				return Promise.reject({
					isUserNotExistMiddleware: true,
					message: response?.data?.message || "User does not exist !",
				});
			}
			return response;
		},
		(error) => Promise.reject(error)
	);
	return instance;
};

const AxiosInstance = (headers) => {
	const CancelToken = axios.CancelToken;
	const source = CancelToken.source();
	const instance = axios.create({
		baseURL: `${process.env.REACT_APP_API_URL}`,
		headers: { ...headers },
		cancelToken: source.token
	});
	return attachApiResponseMiddleware(instance);
}

export const PostAxios = async (url, postData={}, token='', headers={}) => {
	let instance = AxiosInstance({...headers,"Content-Type":'multipart/form-data'});
	return await instance.post(url, {...postData,token});
}

export const GetAxios = (url, token, headers) => {
	let instance = AxiosInstance(headers, token);
	return instance.get(url);
}

export const PutAxios = async (url, postData, token, headers) => {
	let instance = AxiosInstance(headers, token);
	return await instance.put(url, postData);
}
export const TokenExpireOnAPIRequest = (dispatch,data) => {
	dispatch(
		setToastData({
			message: `${data?.message} <h3><a href="${process.env.REACT_APP_WEBSITE_URL}">&laquo; Go to website</a></h3>`,
			isHtml: true,
			type: "error",
		})
	);
	dispatch(setErrorBoundry(true));
	dispatch(logoutUser());
}
export const responseCatchFunc = (dispatch, err) => {
	if (err?.isUserNotExistMiddleware) {
		dispatch(setMainLoading(false));
		return;
	}
	let msg = `${err.message}`;
	if(err.response?.data.code === 400){
		msg = `${err.response?.data.message}`;
	}
	dispatch(
		setToastData({
			message: `${msg}`,
			isHtml: true,
			type: "error",
			showCloseBtn: true
		})
	);
	dispatch(setMainLoading(false));
}